import React, { useCallback, useEffect, useState, KeyboardEvent } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import "./login.css";
import { resetPassword, checkToken } from "../login/resetPassword.utils";
import Button from "../../widgets/button";
import { LOGIN_DIALOGS } from "../../constants/dialog.constants";
import { useNavigate } from "react-router-dom";
import ReactHtmlParser from "html-react-parser";
import { RESET_API, RESET_API_TOKEN } from "../../constants/app.constants";
import LoaderTrans from "../../widgets/loadertrans";
import TextField from "../../widgets/textField/textField";
import PasswordChecklist from "react-password-checklist";

const ResetPassword: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  const [isValid, setIsValid] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isToken, setIsToken] = useState(true);
  const navigate = useNavigate();
  const queryClient = useQueryClient();



  const {
  isLoading: isLoadingToken,
  data: dataToken,
} = useQuery({
  queryKey: [RESET_API_TOKEN, token],
  queryFn: () => checkToken(token as string),
  enabled: !!token,
  refetchOnWindowFocus: false,
});

const {
  isLoading: isLoadingUser,
  data: dataUser,
  isFetching,
  status,
} = useQuery({
  queryKey: [RESET_API, token],
  queryFn: () => resetPassword(token as string, newPassword),
  enabled: isSubmit && !!token && dataToken === "success",
});
  const onChangeFieldValues = useCallback(
    (id: string, updatedValue: string) => {
      if (id === "newPassword") {
        setNewPassword(updatedValue);
      } else if (id === "confirmPassword") {
        setConfirmPassword(updatedValue);
      }
    },
    [newPassword, confirmPassword]
  );

  const handleKeyPress = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        onSubmit();
      }
    },
    [newPassword, confirmPassword]
  );

  const onSubmit = useCallback(() => {
    setErrorMessage("");
    if (newPassword === "" || newPassword === "" || !isValid) {
      setErrorMessage(LOGIN_DIALOGS.invalidResetPassword);
    } else if (newPassword !== confirmPassword) {
      setErrorMessage(LOGIN_DIALOGS.invalidPasswordMismatch);
    } else if (newPassword !== "" && confirmPassword !== "") {
      setIsSubmit(true);
      setIsToken(false);
    }
  }, [newPassword, confirmPassword, isSubmit, isValid]);

  useEffect(() => {
    if (isSubmit && dataUser && isValid) {
      setIsSubmit(false);
      if (dataUser == "success") {
        setErrorMessage(LOGIN_DIALOGS.successResetPassword);
          // ✅ Clear the input fields only on success
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setErrorMessage(LOGIN_DIALOGS.technicalError);
      }
      queryClient.removeQueries();
    } else if (isSubmit && status == "error") {
      setErrorMessage(LOGIN_DIALOGS.loginFailed);
    }
  }, [isSubmit, dataUser, isValid]);

  return (
    <div className="box">
      <h1>RESET PASSWORD</h1>
      {isLoadingToken ? (
        <LoaderTrans msg="Verifying Token" />
      ) : !isLoadingToken &&
        (dataToken == "success" || dataToken == undefined) ? (
        <div>
          <p className="subtitle">Please enter new password</p>
          <div className="frm">
            <TextField
              id="newPassword"
              value={newPassword}
              onChange={onChangeFieldValues}
              className="email inputcls"
              type="password"
              placeholder="Enter New Password"
              onKeyPress={handleKeyPress}
            />
            <TextField
              id="confirmPassword"
              value={confirmPassword}
              onChange={onChangeFieldValues}
              className="pwd inputcls"
              type="password"
              placeholder="Enter Confirm Password"
              onKeyPress={handleKeyPress}
            />

            <div>
              <Button
                data="RESET"
                type="submit"
                onClick={onSubmit}
                className="btnlogin"
              />
              <PasswordChecklist
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={5}
                value={newPassword}
                valueAgain={confirmPassword}
                onChange={(isValid) => {
                  setIsValid(isValid);
                }}
              />
            </div>
          </div>
          {(isLoadingUser || isFetching) && isValid ? (
            <div>
              <LoaderTrans msg="Resetting" />
            </div>
          ) : null}
          <div className="errorMsgStyle">{ReactHtmlParser(errorMessage)}</div>
        </div>
      ) : (
        <div className="errorMsgStyle">
          {ReactHtmlParser(LOGIN_DIALOGS.invalidToken)}
        </div>
      )}
    </div>
  );
};
export default ResetPassword;
